import { useEffect } from 'react';

export function useSticky(wrapperRef, contentWrapper, setSticky) {
    useEffect(() => {
        const target = document.body;
        if (!target) return;
        const scroll = function () {
            if (target.scrollTop > wrapperRef.current.clientHeight) {
                if (contentWrapper.current) {
                    contentWrapper.current.setAttribute('sticky', true);
                    setSticky(true);
                }
            } else {
                if (contentWrapper.current) {
                    contentWrapper.current.removeAttribute('sticky');
                    setSticky(false);
                }
            }
        };
        target.addEventListener('scroll', scroll);
        return () => {
            target.removeEventListener('scroll', scroll);
        };
    }, []);
}
